
import Highcharts from 'highcharts';
require('highcharts/modules/debugger')(Highcharts);
require('highcharts/modules/accessibility')(Highcharts);

window.Highcharts = Highcharts;

import { radar_historie } from 'components/frontend/radar_historie';
import { radar_historie_power } from 'components/frontend/radar_historie';

radar_historie_power('Strom', 'MW');

radar_historie('gas', 'Gas', 'MW');
radar_historie('water', 'Wasser', 'l/s');

